package com.example.mystybag.login.logic

import com.example.mystybag.common.logic.DialogNavigatorForceUpdate
import com.example.mystybag.common.logic.NavigatorVerifyEmailAddress
import com.example.mystybag.communication.login.LoginCommands.sendEnroll
import com.example.mystybag.communication.login.LoginCommands.sendGetCities
import com.example.mystybag.communication.utils.Response
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_CODE
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_EMAIL
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_USER_ID
import com.example.mystybag.core.expected.LogHelper
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.expected.openAppStorePage
import com.example.mystybag.core.helpers.GlobalCommonData.getReferralCodeValue
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.login.model.ChooseCityUIState
import com.example.mystybag.sharedmodels.base.BaseResponseModel
import com.example.mystybag.sharedmodels.defines.ServerStatusDefines.Companion.STATUS_MANDATORY_UPDATE
import com.example.mystybag.sharedmodels.mobileAdmin.database.UsersCredentialTypes
import com.example.mystybag.sharedmodels.project.requestModels.EnrollUserRequestModel
import com.example.mystybag.sharedmodels.project.responseModels.CityResponseModel

class ChooseCityViewModel(
    context: AppContext,
    val userId: Long,
    val email: String,
    val credentialTypes : UsersCredentialTypes,
    val firstName: String? = null,
    val lastName: String? = null,
    val photoUrl: String? = null,
): ChildViewModel<ChooseCityUIState>(context, ChooseCityUIState()) {
    
    override fun onCreate() {
        loadCities()
    }

    private fun loadCities() {
        updateState { it.copy(isLoading = true) }
        commandBlock {
            sendGetCities()
                .onResponse(
                    success = { response ->
                        launchOnMain {
                            updateState { state ->
                                state.copy(
                                    cities = response.citiesList,
                                    isLoading = false
                                )
                            }
                        }
                    },
                    baseError = { response ->
                        handleError(response)
                    }
                )
        }
    }

    fun onCitySelected(city: CityResponseModel) {
        updateState { state ->
            state.copy(selectedCity = city)
        }
    }

    override fun onSearchTextChanged(text: String) {
        updateState { state ->
            state.copy(searchText = text)
        }
    }

    fun onNextClicked() {
        val selectedCity = uiState.value.selectedCity ?: return
        val cityId = selectedCity.id

        // Flow from EnterEmail / Google: send enroll with cityId, then navigate to verification (or main for social).
        updateState { it.copy(isLoading = true) }
        val request = EnrollUserRequestModel(
            email = email,
            credentialTypes = credentialTypes,
            cityId = cityId,
            firstName = firstName,
            lastName = lastName,
            photoUrl = photoUrl,
            referralCode = getReferralCodeValue(),
        )

        commandBlock {
            sendEnroll(request = request)
                .onResponse(
                    success = { response ->
                        Preferences.clear()

                        Preferences.setString(PREFERENCES_EMAIL, email)
                        Preferences.setString(PREFERENCES_CODE, response.code)
                        Preferences.setLong(PREFERENCES_USER_ID, response.userId)

                        if(credentialTypes == UsersCredentialTypes.STANDARD){
                            launchOnMain {
                                updateState { it.copy(isLoading = false) }
                                navigate(NavigatorVerifyEmailAddress(
                                    userId = response.userId,
                                    email = email,
                                    cityId = cityId
                                ))
                            }
                        }
                        else{
                            setResult<LoginInterface> {
                                goToMainScreen(false, onErrorCallback = {
                                    updateState { uiState -> uiState.copy() }
                                })
                            }
                        }

                    },
                    baseError = { response ->
                        handleError(response)
                    }
                )
        }
    }

    private suspend fun handleError(model: BaseResponseModel) {
        updateState { it.copy(isLoading = false) }
        when (model.status) {
            STATUS_MANDATORY_UPDATE -> showDialog(DialogNavigatorForceUpdate).onPositiveClick { openAppStorePage() }
            else -> showSnackbar(Response.getErrorMessage(model.status, model.apiEndPoint, model.statusMessage))
        }
    }
}

